// extracted by css-extract-rspack-plugin
export default {"serverQueryOpSummary":"serverQueryOpSummary-TenCL7"};